<template>
  <exclusive-offer-toast
    success
    :message="message"
    event="qualificationReclaimed"
    class="qualification_reclaim_toast"
  />
</template>

<script>
import ExclusiveOfferToast from './ExclusiveOfferToast.vue'
import config from '../../js/qualificationsConfigService'

export default {
  components: {
    ExclusiveOfferToast,
  },
  data() {
    return {
      message: ''
    }
  },
  mounted() {
    this.message = config.getTdcString('tdc_reclaimToastSuccess')
  },
}
</script>

<style>

</style>
